<template>
  <div class="modal-non-participant">
    <SimpleModal>
      <div class="modal-non-participant__p">
        Wilt u dat {{ selectedNonParticipant.name }} ook mee gaat doen met
        OmgevingsAlert? Neem dan contact op met de gemeente.
      </div>
      <div class="modal-non-participant__list">
        <a
          class="modal-non-participant__list__button"
          target="_blank"
          :href="tweetHref"
          >Stuur tweet</a
        >
        <a :href="phoneNumber" class="modal-non-participant__list__button"
          >Bel {{ this.selectedNonParticipant.phone }}</a
        >
        <button
          class="modal-non-participant__list__button"
          @click="closeModalNonParticipant"
        >
          Annuleer
        </button>
      </div>
    </SimpleModal>
  </div>
</template>

<script>
import SimpleModal from "@/components/SimpleModal.vue";

export default {
  components: {
    SimpleModal
  },
  props: {
    selectedNonParticipant: {
      type: Object,
      required: true
    }
  },
  computed: {
    phoneNumber() {
      return `tel: ${this.selectedNonParticipant.phone}`;
    },
    tweetHref() {
      return `https://twitter.com/intent/tweet?screen_name=${this.selectedNonParticipant.twitter.slice(
        1
      )}`;
    }
  },
  methods: {
    closeModalNonParticipant() {
      this.$store.commit("closeModalNonParticipant");
    }
  }
};
</script>

<style scoped lang="scss">
.modal-non-participant {
  &__p {
    @extend %text-large;
  }
  &__list {
    margin: 24px -24px -24px;

    &__button {
      display: inline-block;
      line-height: 45px;
      height: 45px;
      width: 100%;
      color: $color-green-1;
      @extend %text-medium;
      text-align: center;
      border-top: 1px solid $color-gray-1;

      &:last-child {
        color: $color-black-3;
      }
    }
  }
}
</style>
